import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const StoreRedirect = () => {
  const { influencerName } = useParams();

  useEffect(() => {
    if (influencerName) {
      const appDeepLink = `myapp://store/${influencerName}`;
      const fallbackUrl = `${window.location.origin}/fallback/${influencerName}`;

      console.log(`Redirection vers l'application avec l'influenceur : ${influencerName}`);

      // Essayer d'ouvrir l'application avec un lien profond
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = appDeepLink;
      document.body.appendChild(iframe);

      // Si l'application ne s'ouvre pas, rediriger vers le fallback
      setTimeout(() => {
        window.location.href = fallbackUrl;
      }, 1500);
    }
  }, [influencerName]);

  return (
    <div>
      <h1>Redirection en cours...</h1>
      <p>Vous allez être redirigé pour l'influenceur : <strong>{influencerName}</strong></p>
      <a href={`${window.location.origin}/fallback/${influencerName}`}>
        Cliquez ici si rien ne se passe.
      </a>
    </div>
  );
};

export default StoreRedirect;